export default "__VITE_ASSET__BmvjynK7__"